import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { locale, t } from "../MainApp";

type BreadcrumbsProps = {
    isMakingNewReservation: boolean;

    locale: locale,
};

export function Breadcrumbs(props: BreadcrumbsProps) {

    return (
        <Breadcrumb>
            <Breadcrumb.Item>
                <Link to="/">{t(props.locale, "home")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                {props.isMakingNewReservation  
                    ? t(props.locale, "newReservation") 
                    : t(props.locale, "updateReservation") 
                }
            </Breadcrumb.Item>
        </Breadcrumb>
    );
}